import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isAIPage = location.pathname === '/';
  const isServicesPage = location.pathname === '/services';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.hash) {
      if (location.pathname !== item.route) {
        navigate(item.route);
        setTimeout(() => {
          const el = document.getElementById(item.hash.replace('#', ''));
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      } else {
        const el = document.getElementById(item.hash.replace('#', ''));
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      navigate(item.route);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
        <div className={styles.container}>
          <button className={styles.logo} onClick={() => { navigate('/'); window.scrollTo({ top: 0 }); }}>
            BlueprintX
          </button>

          <nav className={styles.desktopNav} aria-label="Site navigation">
            <button
              className={`${styles.tabBtn} ${isAIPage ? styles.tabActive : ''}`}
              onClick={() => { navigate('/'); window.scrollTo({ top: 0 }); }}
            >
              BlueprintX AI
            </button>
            <button
              className={`${styles.tabBtn} ${isServicesPage ? styles.tabActive : ''}`}
              onClick={() => { navigate('/services'); window.scrollTo({ top: 0 }); }}
            >
              Services
            </button>
          </nav>

          <button
            className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            <span className={styles.hamburgerLine} />
            <span className={styles.hamburgerLine} />
            <span className={styles.hamburgerLine} />
          </button>
        </div>
      </header>

      <div className={`${styles.overlay} ${menuOpen ? styles.overlayOpen : ''}`}>
        <nav className={styles.overlayNav} aria-label="Main navigation">
          <button
            onClick={() => { navigate('/'); window.scrollTo({ top: 0 }); setMenuOpen(false); }}
            className={`${styles.overlayLink} ${isAIPage ? styles.active : ''}`}
          >
            BlueprintX AI
          </button>
          <button
            onClick={() => { navigate('/services'); window.scrollTo({ top: 0 }); setMenuOpen(false); }}
            className={`${styles.overlayLink} ${isServicesPage ? styles.active : ''}`}
          >
            Services
          </button>
          <button
            onClick={() => handleNav({ route: '/services', hash: '#contact' })}
            className={styles.overlayLink}
          >
            Contact
          </button>
        </nav>
      </div>
    </>
  );
};

export default Header;
